import React from 'react';
import PropTypes from 'prop-types';
import Dummy from '/utils/dummy.js';
import {
    isMobile,
} from "react-device-detect";
import {c} from '/utils/log';
import { Router } from '/routes';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
// import Clappr from '/static/clappr/dist/clappr.min.js';

const localStyles = theme => ({
    overlay: {
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.3)',
        zIndex: -1
    },
    videoPlaceholder:{
        width: '100%',
        // height: 411,
        zIndex: 2,
        position: 'relative',
        background: 'rgba(0, 0, 0, 0.5)',
        [theme.breakpoints.down('md')]: {
          height: 'calc(100vw * 0.5625)',
        },
    },
    btnLabel: isMobile ? {
        display: 'flex',
        backgroundColor: '#fff',
        maxWidth: '142px',
        borderRadius: '4px',
        padding: '4px 0',
        position: 'absolute',
        top: '16px',
        left: '16px',
    } : {
        display: 'flex'
    },
    btnRoot: isMobile ? {
        position:'absolute',
        color: '#000',
        zIndex:999,
        top: '0',
        left: '0',
        backgroundColor: 'rgba(0,0,0,0.1)',
        width: '100%',
        height: '100%',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    } : {
        position:'absolute',
        top:'14px',
        left: '14px',
        color: '#000',
        backgroundColor:'#fff',
        zIndex:999,
    },
    //   playerStyle: {
    //       width: 'inherit',
    //       height: 'inherit',
    //     //   position: 'inherit',
    //     //   bottom: 20
    //   }
})

class ClapprPlayer extends React.Component {

  constructor(props) {
    super(props);

    this.getPagePath = this.getPagePath.bind(this);
    this.pushDataLayer = this.pushDataLayer.bind(this);
    this.pushEventAndProperties = this.pushEventAndProperties.bind(this);

    this.change = this.change.bind(this);
    this.destroyPlayer = this.destroyPlayer.bind(this);

    this.Clappr = require('clappr');
    // this.LevelSelector = require('/static/clappr/plugins/level-selector.min.js');
    this.LevelSelector = require('level-selector');
    // this.ClapprImaPlugin = require('clappr-ima-plugin');
    this.CDNByeClapprPlugin = require('cdnbye');
    this.ClapprGaEventsPlugin = require('clappr-ga-events-plugin');
    this.onPlay = this.onPlay.bind(this);
    this.onReady = this.onReady.bind(this);
    this.onEnded = this.onEnded.bind(this);
    this.doUnMute = this.doUnMute.bind(this);
    this.doCountDown = this.doCountDown.bind(this);
    this.onUnMute = this.onUnMute.bind(this);
    this.onEndedCountdown = this.onEndedCountdown.bind(this);
  }

  shouldComponentUpdate (nextProps, nextState) {
    const changed = (nextProps.source != this.props.source);
    this.props = nextProps;
    this.state = nextState;
    if (changed) {
      this.change(nextProps.source);
    }
    return false;
  }

  componentDidMount() {
    this.change(this.props.source);
    window.videoDetailCardFloated = true;
  }

  componentWillUnmount() {
    this.destroyPlayer();
    window.videoDetailCardFloated = false;
  }

  getPagePath() {
    if (this.props.pagePath)
        return this.props.pagePath;

    const video = this.props.video;
    const tvTypeIndex = video.categories && video.categories.findIndex((category) => category.type === 'TV')
    const type = tvTypeIndex >= 0 ? 'tv' : 'videos';
    if (this.props.isWidget) {
        return `/${type}/${video.slug}`;
    }
    else if (this.props.isPlayListURL) {
        return `/${type}/${video.slug}?list=${this.props.playlist.playlist_id}`;
    }

    return 'Undefined pagePath';
  }

  pushDataLayer(e) {
    if (window.self === window.top) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(e);
    }
    else {
        parent.dataLayer = parent.dataLayer || [];
        parent.dataLayer.push(e);
    }
  }

  pushEventAndProperties(event, eventCategory, eventAction) {
    const video = this.props.video;
    this.pushDataLayer({
        event: event,
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: video && video.title ? video.title : 'No Title',
        jwplayerWidgetPage:  this.getPagePath(),
        jwplayerWidgetTitle: video && video.title ? video.title : 'No Title',
        channel: video && video.categories && video.categories.length ? video.categories.map(e => e.slug).join() : 'No Channel'
    });
  }

  destroyPlayer() {
    if (this.player) {
      this.player.destroy();
    }
    this.player = null;
  }

  doCountDown(nextVideo, playlistId) {
        const tvTypeIndex = nextVideo.categories && nextVideo.categories.findIndex((category) => category.type === 'TV')
        const routeName = tvTypeIndex >= 0 ? 'tvDetail' : 'videoDetail';
        const slug = nextVideo.slug;
        const title = nextVideo.title;
        const brandRouteName = tvTypeIndex >= 0 ? 'brandTvDetail' : 'brandVideoDetail';

        let upnext_wrapper = `<div class='upnext-title-style'><div class='upnext-style'>Up Next</div>${  title }</div>`;
        const countdown_html = `
            <div id="countdown">
                <div id="countdown-number"></div>
                <div class="arrow-right"></div>
                <svg>
                    <circle r="36" cx="40" cy="40"></circle>
                </svg>
            </div>
            <div id="countdown-cancel">
                Cancel
            </div>
        `;
        const countdown_html_mobile = `
            <div id="countdown">
                <div id="countdown-number"></div>
            <svg>
                <circle r="22" cx="25" cy="25"></circle>
            </svg>
            </div>
            <div id="countdown-cancel">
                Cancel
            </div>
        `;

        const countdown_wrapper = document.createElement('div');
        countdown_wrapper.setAttribute("id", "countdown-wrapper");
        countdown_wrapper.innerHTML = isMobile ? upnext_wrapper += countdown_html_mobile : upnext_wrapper += countdown_html;
        const player_overlay = document.getElementById('player-overlay');
        player_overlay.style.zIndex = 2;
        player_overlay.insertBefore(countdown_wrapper, player_overlay.firstChild);
        const countdownNumberEl = document.getElementById('countdown-number');
        let countdown = 5;

        countdownNumberEl.textContent = countdown;
        const myCountDown = setInterval(() => {
            if(countdown == 1)
                redirectNextVideo();
            countdown = (--countdown <= 0) ? 5 : countdown;
            countdownNumberEl.textContent = countdown;
        }, 1000);

        const clearCountdown = () => {
            player_overlay.style.zIndex = -1;
            clearInterval(myCountDown);
            player_overlay.removeChild(countdown_wrapper);
        };
        var redirectNextVideo = () => {
            clearCountdown();
            // Router.pushRoute(routeName, {id : slug} )
            c.log('ppp')
            // c.log( playlist.videos[playlistIndex[1]].slug)
            Router.pushRoute(nextVideo.sponsor ? brandRouteName : routeName, nextVideo.sponsor? { brand: nextVideo.sponsor.slug , id: nextVideo.slug } : playlistId ? {id: slug, list: playlistId} : {id : slug})
        };
        const countdown_ele = document.getElementById("countdown");
        countdown_ele.onclick = redirectNextVideo;

        const countdown_cancel = document.getElementById("countdown-cancel");
        countdown_cancel.onclick = clearCountdown;
    }

  doUnMute() {
    if(!window.PlayerUnMuted){
        this.player.setVolume(100);
        document.getElementById("unmute-button").style.display = 'none';
    }
    window.PlayerUnMuted = true;
  }

  onUnMute() {
    console.log("onUnMute Clappr");
    window.PlayerUnMuted = true;
    document.getElementById("unmute-button").style.display = 'none';
  }

  onPlay() {
    console.log('onPlay');
    this.pushEventAndProperties('jwPlayerPlay', 'video', 'play');
  }

  onReady() {
      console.log('onReady');

      if(this.props.isWidget) {
        const video = this.props.video;
        this.pushDataLayer({
            event: 'jwplayerWidget',
            jwplayerWidgetPage: this.getPagePath(),
            jwplayerWidgetTitle: video && video.title ? video.title : 'No Title',
            channel: video && video.categories && video.categories.length ? video.categories.map(e => e.slug).join() : 'No Channel'
        })
      }

      this.pushEventAndProperties('jwPlayerVideoLoad', 'video', 'load');

      window.IsAutoPlaySupported = true;
      if(!window.PlayerUnMuted)
          document.getElementById("unmute-button").style.display = 'inline';
  }

  onEnded() {
    console.log('onEnded');
    this.pushEventAndProperties('jwPlayerOneHundredPercentWatched', 'video', 'end');

    const { upNext, playlist, playlistPos, slickGoToProp, routeParams, routeName } = this.props;
      if(upNext){
        Router.pushRoute(routeName, routeParams )
        slickGoToProp.slickGoTo(playlistPos)
      }
  }

  onEndedCountdown() {
    console.log('onEndedCountdown');
    this.pushEventAndProperties('jwPlayerOneHundredPercentWatched', 'video', 'end');

    const { upNext, isPlayListURL, playlist, playlistPos } = this.props;
    const nextPlayListVideo = playlist && playlist.video_count != playlistPos ? playlist.videos[playlistPos] : null;
    if(isPlayListURL) {
      if(nextPlayListVideo)
          this.doCountDown(nextPlayListVideo, playlist.playlist_id);
      }
      else if(upNext)
        this.doCountDown(upNext, null);
    }


  change (source) {
    if (this.player) {
      this.destroyPlayer();
    }

    const Clappr = this.Clappr;
    const LevelSelector = this.LevelSelector;
    // const ClapprImaPlugin = this.ClapprImaPlugin;
    const CDNByeClapprPlugin = this.CDNByeClapprPlugin;
    const ClapprGaEventsPlugin = this.ClapprGaEventsPlugin;

    const { id, width, height, poster, autoPlay, onPause, onVideoLoad, video, upNext, isWidget } = this.props
    const that = this;
    this.player = new Clappr.Player({
      // parent: `#${id}`,
      parent: this.refs.player,
      source,
      poster,
      baseUrl: process.env.IS_LOCALHOST ? "http://localhost:3001/static/clappr/dist" : "https://www.duwun.com.mm/static/clappr/dist",
      mute: !window.PlayerUnMuted,
      loop: false,
      hideVolumeBar: true,
      width,
      height,
      autoPlay,
      useHardwareVideoDecoder: false,
      playback: {
        preload: 'metadata',
        controls: false,
        playInline: true, // allows inline playback when running on iOS UIWebview
        recycleVideo: Clappr.Browser.isMobile, // Recycle <video> element only for mobile. (default is true)
        triggerFatalErrorOnResourceDenied: true, // Triggers playback fatal error if resource is denied. (default is false)
        p2pConfig: {
          logLevel: 'debug',
          live: false,        // set to true in live mode
          getStats: function (totalP2PDownloaded, totalP2PUploaded, totalHTTPDownloaded) {
            let total = totalHTTPDownloaded + totalP2PDownloaded;
            document.querySelector('#info').innerText = `p2p ratio: ${Math.round(totalP2PDownloaded / total * 100)}%, saved traffic: ${totalP2PDownloaded}KB, uploaded: ${totalP2PUploaded}KB`;
            }
          }
        },
      events: {
          onPlay: this.onPlay,
          onPause,
          onReady: this.onReady,
          onEnded: isWidget ? this.onEnded : this.onEndedCountdown,
          onVideoLoad,
       },
      hlsjsConfig: {
          startLevel: 3,
          enableWorker: true,
          maxBufferSize: 0,
          maxBufferLength: 30,
          liveSyncDuration: 30,
        //   abrEwmaDefaultEstimate: 5500000
        },
      plugins: [
          CDNByeClapprPlugin,
          // ClapprImaPlugin,
          LevelSelector,
          ClapprGaEventsPlugin
      ],
      levelSelectorConfig: {
          title: 'Quality',
          labels: {
            6: '1280p',
            5: '1080p', // 4HD
            4: '720p', // HD
            3: '480p', // 500kbps
            2: '360p', // 240kbps
            1: '240p',
            0: '144p', // 120kbps
          },
          defaultQuality: 4, // start with quality 4 or Lowest
        },
      // imaPlugin: {
      //     imaAdPlayer: {
      //       tag: 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/ad_rule_samples&ciu_szs=300x250&ad_rule=1&impl=s&gdfp_req=1&env=vp&output=vmap&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ar%3Dpremidpost&cmsid=496&vid=short_onecue&correlator=',
      //     }
      // },
      gaEventsPlugin: {
          trackingId: 'UA-67701357-1',
          eventCategory: 'video',
          eventLabel: video.title,
        //   eventToTrack: ['play', 'ended', 'loadedmetadata'],
        //   eventMapping: {
        //     loadedmetadata: 'load',
        //     ended: 'end'
        //   },
          sendPlayOnce: true, //autoPlay
          progressSecondsCategory: 'video',
          progressSeconds: [3,10,30],
          progressSecondsAction: function(i) {
              switch(i) {
                  case 3:
                    that.pushEventAndProperties('jwPlayerThreeSecondsView', 'video', 'viewed 3 seconds');
                    break;
                  case 10:
                    that.pushEventAndProperties('jwPlayerTenSecondsView', 'video', 'viewed 10 seconds');
                    break;
                  case 30:
                    that.pushEventAndProperties('jwPlayerThritySecondsView', 'video', 'viewed 30 seconds');
                    break;
                  default:
                    break;
              }
              console.log('viewed ' + i + ' seconds');
              return 'viewed ' + i + ' seconds'
            },
          progressPercentCategory: 'video',
          progressPercent: [25,50,75,95],
          progressPercentAction: function(i) {
              switch(i) {
                case 25:
                  that.pushEventAndProperties('jwPlayerTwentyFivePercentWatched', 'video', 'watched 25%');
                  break;
                case 50:
                  that.pushEventAndProperties('jwPlayerFiftyPercentWatched', 'video', 'watched 50%');
                  break;
                case 75:
                  that.pushEventAndProperties('jwPlayerSeventyFivePercentWatched', 'video', 'watched 75%');
                  break;
                case 95:
                  that.pushEventAndProperties('jwPlayerNinetyFivePercentWatched', 'video', 'watched 95%');
                  break;
                default:
                  break;
              }
              console.log('watched ' + i + ' %');
              return 'watched ' + i + '%'
            }

      },
    });
    if(this.Clappr.Browser.isMobile)
        this.player.getPlugin('click_to_pause').disable();
    /**
     * listen to an event indefinitely, if you want to stop you need to call `off`
     * @method on
     * @param {String} name
     * @param {Function} callback
     * @param {Object} context
     */
    this.player.core.getCurrentPlayback().on(
      Clappr.Events.PLAYBACK_READY,
      () => {
          console.log('PLAYBACK_READY')
        }
    );
    this.player.core.getCurrentPlayback().on(
      Clappr.Events.PLAYBACK_PLAY_INTENT,
      () => {
          console.log('PLAYBACK_PLAY_INTENT');
          if(this.props.autoPlay) {
            console.log('autoplay');
            this.pushEventAndProperties('jwPlayerAutoPlayCount', 'video', 'autoplay');
          }
        }
    );
  }

  render() {
    const { id, classes, video } = this.props
    return (
        <div className={classes.videoPlaceholder}>
            <div id="player-overlay" />
            <Button
                classes={{root: classes.btnRoot, label: classes.btnLabel}}
                variant="contained"
                id="unmute-button"
                style={{ display: window.PlayerUnMuted ? 'none': window.IsAutoPlaySupported ? 'inline' : 'none'}}
                onClick={() => this.doUnMute()}
            >
                <Icon>volume_off</Icon>
                <Typography component="span" style={{ paddingLeft: 5, lineHeight: '23px' }}>အသံဖွင့်ရန်နှိပ်ပါ</Typography>
                {/* <Typography onClick={() => this.doUnMute()} component="span" style={{ paddingLeft: 5 }}>Tap to unmute</Typography> */}
            </Button>
            <div ref="player" id={id} />
        </div>
    );
  }
}

ClapprPlayer.propTypes = {
  source: PropTypes.string,
  poster: PropTypes.string,
  id: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  autoPlay: PropTypes.bool,
  onPlay: PropTypes.func,
  onPause: PropTypes.func
};

export default withStyles(localStyles)(ClapprPlayer);
